import React from "react";
import PropTypes from "prop-types";
import Button from "../buttons/Button";
import { useTranslation } from "react-i18next";
import AlertContainer from "../AlertContainer";
import InputMarkdown from "shared/components/inputs/InputMarkdown";

import "./style.scss";

const OkDialog = ({
    title,
    message,
    image,
    label,
    onConfirm,
    onCancel,
    onChange,
    defaultValue
}) => {

    const [t] = useTranslation();

    return (
        <div className="ok-dialog">
            <AlertContainer>
                <img alt="question" src={image || require("../../assets/img/okki-question.png")} />
                <h3>{title}</h3>
                <div className="spacer" />
                <p>{message}</p>
                <div className="spacer-double" />
                <InputMarkdown
                    label={label}
                    defaultValue={defaultValue}
                    onChange={onChange} />
                <div className="spacer" />
                <div className="actions cols">
                    {onCancel &&
                        <div className="col">
                            <Button
                                outlined
                                testId="button-cancel"
                                fullWidth
                                onClick={onCancel}
                                label={t("button.cancel.label")}
                            />
                        </div>}
                    {onConfirm && <div className="col">
                        <Button
                            fullWidth
                            secondary
                            testId="button-confirm"
                            onClick={onConfirm}
                            label={t("button.confirm.label")}
                        />
                    </div>}
                </div>
            </AlertContainer>
        </div>
    );
};

OkDialog.propTypes = {
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    image: PropTypes.object,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func,
    labelConfirm: PropTypes.string,
    labelCancel: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func,
    defaultValue: PropTypes.string
};

export default OkDialog;